import { YearQuarterBuilder } from '~/models';
import { DEFAULT_STARTING_DATE } from '~/lib/constants';
// ---- internal imports -----


function createNewQuarter(quarterNum) {
	return new YearQuarterBuilder()
		.withQuarterNum(quarterNum)
		.withFromDate(DEFAULT_STARTING_DATE)
		.build();
}

function getDisplayedStatementBasedOnSubmissionErrors(errorMessages) {
	if (errorMessages['incomeStatement'].length > 0) {
		return 'incomeStatement';
	}

	if (errorMessages['equityStatement'].length > 0) {
		return 'equityStatement';
	}

	return 'balanceSheet';
}

export {
	createNewQuarter,
	getDisplayedStatementBasedOnSubmissionErrors,
};
